<template>
  <el-dialog title=""
             :custom-class="'coupon-list-popover ' + popperClass"
             :show-close="false"
             width="450px"
             :visible.sync="visibleValue"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :modal-append-to-body="true"
             :append-to-body="true"
             @close="closeCallback"
             @closed="closedCallback">
    <div class="coupon-list-wrap" :style="`background-image:url(${images.bg_coupon});`">
      <div class="coupon-title">
        <slot name="title">
          <img :src="images.title_img" class="title-img" alt="限时优惠券">
        </slot>
      </div>
      <div class="list-box">
        <slot>
        </slot>
      </div>
      <div class="footer-row">
        <slot name="footer">
          <get-coupon-button :button-text="buttonText"
                             @clickButton="clickButton"></get-coupon-button>
        </slot>
      </div>
    </div>
    <div class="custom-close" @click="closedDialog">
      <i class="el-icon-circle-close"></i>
    </div>
  </el-dialog>
</template>

<script>
import {mixinsDialog} from "my-element-mixins";
import GetCouponButton from "./getCouponButton";

export default {
  name: "couponPopover",
  components: {GetCouponButton},
  mixins:[mixinsDialog],
  props:{
    popperClass:{
      type:String,
      default:"",
    },
    buttonText:{
      type:String,
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        bg_coupon: ossPath + "/pages/home/coupon/bg_coupon.png",
        bg_coupon_item: ossPath + "/pages/home/coupon/bg_coupon_item.png",
        title_img: ossPath + "/pages/home/coupon/coupon_title_1.png",
      },
    }
  },
  methods:{
    /**
     * 关闭弹窗前回调
     */
    closeCallback() {
      this.$emit('close');
    },
    clickButton(){
      this.$emit("clickButton");
    },
  }
}
</script>

<style lang="scss">
.coupon-list-popover{
  background-color: transparent !important;
  box-shadow: none !important;
  .el-dialog__header{
    display: none
  }
  .el-dialog__body{
    padding: 0;
  }
}
</style>
<style scoped lang="scss">
.coupon-list-wrap{
  width: 427px;
  height: 529px;
  margin: 0 auto;
  overflow: hidden;
  .coupon-title{
    width: 296px;
    height: 100px;
    margin: 66px auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .title-img{
      display: block;
      width: auto;
      height: auto;
    }
  }
  .list-box{
    width: 340px;
    height: 200px;
    margin: 70px auto 20px;
    overflow: hidden;
  }
  .footer-row{
    width: 340px;
    height: 72px;
    margin: 0 auto;
  }
}
.custom-close{
  position: absolute;
  bottom: -50px;
  left: 50%;
  margin-left: -20px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 22px;
  color: white;
  &:hover{
    color: #FF4D01;
  }
}
</style>



// WEBPACK FOOTER //
// common/couponPopover/index.vue